import React from "react";
import { CheckOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

export const SelectListItem = ({
  label,
  isHeading,
  onClick,
  isActive,
  tooltip,
}: {
  label: string;
  isHeading?: boolean;
  onClick?: any;
  isActive?: boolean;
  tooltip?: string;
}) => {
  return (
    <li
      className={
        !isHeading
          ? "select-list__item"
          : "select-list__item select-list__item--heading"
      }
    >
      {isHeading ? (
        <>{label}</>
      ) : (
        <button
          className={
            !isActive
              ? "select-list__button"
              : "select-list__button select-list__button--active"
          }
          onClick={onClick}
        >
          {isActive && (
            <div className="select-list__icon-circle">
              <CheckOutlined className="select-list__icon" />
            </div>
          )}
          <div className="select-list__label">{label}</div>
          {tooltip && (
            <Tooltip placement="topLeft" arrowPointAtCenter title={tooltip}>
              <QuestionCircleOutlined className="icon icon--interactive select-list__icon-tooltip" />
            </Tooltip>
          )}
        </button>
      )}
    </li>
  );
};
